export default __webpack_public_path__ + "static/media/topic.b7cbc675.jpg";